<template lang="pug">
.property(v-if="! hidden" :class="{ selectable }")
    .label(v-if="property.label && !hideLabel")
        label {{ property.label }}
    
    .value(v-if="value && type === 'color'")
        // TODO: check for image swatch
        .color-prop(v-if="valueAlt")
            .tile(:style="{ background: valueAlt }")
            span(v-html="value")
        span(v-else v-html="value")
    .value(v-else-if="value && type === 'number'")
        span(v-html="value | parseInt")
    .value(v-else-if="value && type === 'unit'")
        span(v-html="Math.round(value * 100) / 100")
    .value(v-else v-html="value")

    .options(v-else-if="options")
        button.button.is-small.is-link.option(
            v-for="option in options"
            :class="{ 'is-active': activeOption && activeOption.id === option.id, 'is-not-available': !option.available, 'is-out-of-stock': !option.sellable }"
            :disabled="!valid || !validArticles || !validArticles.length || !option.sellable"
            @click="select(option)"
        )
            template(v-if="type !== 'color' || type !== 'number'") test
            template(v-else-if="type === 'number'") test
            template(v-else)
                .color-prop(v-if="option.valueAlt")
                    .tile(:style="{ background: option.valueAlt }")
                    span {{ option.value }}
                span(v-else) {{ option.value }}
</template>

<script>
import nl2br from 'nl2br';

export default {
    name: 'ProductProperty',
    props: {
        property: {
            type: Object,
            required: true
        },
        validArticles: {
            type: Array,
            required: false
        },
        sellableArticles: {
            type: Array,
            required: false
        },
        activeOption: {
            type: Object,
            required: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        manageStock: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        parseInt: value => parseInt(value),
        parseFloat: value => parseFloat(parseFloat(value).toFixed(2))
    },
    computed: {
        hidden() {
            return !this.property.options.length;
        },
        selectable() {
            return this.property.options.length > 1;
        },
        type() {
            return this.property.type;
        },
        value() {
            if (this.selectable || this.hidden) return undefined;
            return nl2br(this.property.options[0].value || this.property.options[0].valueAlt);
        },
        valueAlt() {
            if (this.selectable || this.hidden) return undefined;
            return nl2br(this.property.options[0].valueAlt);
        },
        options() {
            if (!this.selectable || this.hidden) return undefined;
            let options = this.property.options;

            options.forEach(option => {
                let sellable = true;
                if (this.property.articleRequired && this.sellableArticles && this.sellableArticles.length) {
                    // check if is sellable
                    // ---
                    // sellable means there is some stock
                    // for any article with this property value
                    sellable = false;

                    const relatedSellableArticles = this.sellableArticles.filter(article => {
                        // pay attention to stock
                        let match = false;
                        article.propertyPivots.forEach(el => {
                            const property = el.property;
                            const value = el.value;

                            if (this.property.id === property.id && value[option.key] === option.value) match = true;
                        });
                        return match;
                    });

                    sellable = !!relatedSellableArticles.length;
                }
                option.sellable = sellable;

                let available = true;
                if (
                    this.property.articleRequired &&
                    !this.activeOption &&
                    this.validArticles &&
                    this.validArticles.length
                ) {
                    // check if is available
                    // ---
                    // available means there is some stock
                    // for articles with all property values matching the current selection
                    // NOTE: keep the cart in mind

                    available = false;

                    const relatedAvailableArticles = this.validArticles.filter(article => {
                        // pay attention to stock
                        let match = false;
                        article.propertyPivots.forEach(el => {
                            const property = el.property;
                            const value = el.value;

                            if (this.property.id === property.id && value[option.key] === option.value) match = true;
                        });
                        return match;
                    });

                    available = !!relatedAvailableArticles.length;
                }
                option.available = available;
            });

            return options;
        }
    },
    methods: {
        select(option) {
            this.$emit('select', { property: this.property, option });
        }
    }
};
</script>

<style lang="sass" scoped>
.label
    font-weight: 500
    // label
    //   padding-bottom: .175em // fix text position
.value
    min-height: 34px
    // padding-left: 2px
    font-weight: 350
    // padding-bottom: .175em // fix text position
    // button
    //   @apply h-8 px-4
    //   padding-bottom: .175em // fix text position
    //   margin: 2px
    //   pointer-events: none
.color-prop
    display: grid
    grid-template-rows: 18px
    grid-template-columns: max-content auto
    grid-gap: 4px
    .tile
        @apply border-1 border-gray-400
        width: 18px
        height: 18px
        display: inline-block
    span
        line-height: 18px
button
    margin: 2px
    &.is-link.option
        color: #000!important
        background-color: #fff!important
        border: 2px solid #000!important
        border-radius: 0px!important
        width: 40px
        height: 40px
        padding: 0!important
        &:hover
            color: #000!important
    .tile
        margin-left: -10px
.is-not-available
    opacity: .5
.options
    margin-left: -2px
</style>
